module.exports = __webpack_public_path__ + "media/site_templates/www.pianomovingservice.com.au/images/testimonials-e2d6a1cc5401de105be1fedf0499a6ab.jpg";